/** @format */

import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Button } from 'semantic-ui-react';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';

export default class BackButton extends Component {
  constructor(props) {
    super(props);
    this.props = props;
  }

  render() {
    const { path } = this.props;
    return (
      <Button
        as={Link}
        key="Back"
        compact
        icon
        color="red"
        labelPosition="left"
        floated="right"
        style={{ marginTop: '2.4em' }}
        to={path}
      >
        <FontAwesomeIcon
          icon={faArrowLeft}
          className="icon"
          style={{ padding: '0.4em' }}
        />
        Back
      </Button>
    );
  }
}

BackButton.propTypes = {
  path: PropTypes.string.isRequired,
};
